import Swal from "sweetalert2";

const LOCKED_PREFIXES = [
  "/menu",
  "/add-menu",
  "/edit-menu",
  "/manage-menu",
  "/menu-details",
  "/categories",
  "/add-category",
  "/edit-category",
  "/category-details",
  "/subcategories",
  "/subcategoriesList",
  "/add-subcategory",
  "/edit-subcategory",
  "/subcategory-details",
  "/products",
  "/create-product",
  "/add-product",
  "/add-new-product",
  "/edit-product",
  "/product-sheet",
  "/items",
  "/add-item",
  "/edit-item",
  "/item-details",
  "/choices",
  "/add-choice",
  "/edit-choice",
  "/choice-details",
  "/clients",
  "/events",
  "/start-now",
];

export function isPlanLockedMenuKey(menuKey) {
  const key = String(menuKey || "");
  return key === "kitchen" || key === "clients" || key === "events" || key.startsWith("kitchen-");
}

export function isPlanLockedPath(pathname) {
  const path = String(pathname || "").replace(/\/+$/, "") || "/";
  return LOCKED_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function promptBuyPlan(t, navigate) {
  return Swal.fire({
    icon: "warning",
    title: t("planExpiredTitle", { defaultValue: "Plan expired" }),
    text: t("planExpiredLocked", {
      defaultValue:
        "Menu & kitchen, Guests, and Events are locked. Buy a plan to use them.",
    }),
    confirmButtonText: t("buyPlan", { defaultValue: "Buy a plan" }),
    showCancelButton: true,
    cancelButtonText: t("cancel"),
    confirmButtonColor: "#fa8072",
  }).then((result) => {
    if (result.isConfirmed && navigate) navigate("/plans");
  });
}
